/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum REGIONS {
  AQ = 'AQ',
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  KR = 'KR',
  NL = 'NL',
  NZ = 'NZ',
  PT = 'PT',
  US = 'US',
  ZA = 'ZA',
}

export enum LANGUAGES {
  ca = 'ca',
  de = 'de',
  en = 'en',
  es = 'es',
  fr = 'fr',
  it = 'it',
  ko = 'ko',
  nl = 'nl',
  pt = 'pt',
}

export enum LOCALES {
  ca_es = 'ca-ES',
  de_ch = 'de-CH',
  de_de = 'de-DE',
  en_aq = 'en-AQ',
  en_ca = 'en-CA',
  en_ch = 'en-CH',
  en_de = 'en-DE',
  en_es = 'en-ES',
  en_gb = 'en-GB',
  en_kr = 'en-KR',
  en_nl = 'en-NL',
  en_nz = 'en-NZ',
  en_us = 'en-US',
  en_za = 'en-ZA',
  es_es = 'es-ES',
  fr_ca = 'fr-CA',
  fr_ch = 'fr-CH',
  fr_fr = 'fr-FR',
  it_ch = 'it-CH',
  ko_kr = 'ko-KR',
  nl_nl = 'nl-NL',
  pt_pt = 'pt-PT',
}

export enum DOMAINS {
  aq = '.aq',
  ca = '.ca',
  ch = '.ch',
  de = '.de',
  es = '.es',
  fr = '.fr',
  uk = '.co.uk',
  kr = '.kr',
  nl = '.nl',
  nz = '.co.nz',
  pt = '.pt',
  com = '.com',
  za = '.co.za',
  io = '.io',
}

export enum CURRENCY_CODE_FORMAT {
  ca_es = 'EUR',
  de_ch = 'CHF',
  de_de = 'EUR',
  en_aq = 'USD',
  en_ca = 'CAD',
  en_ch = 'CHF',
  en_de = 'EUR',
  en_es = 'EUR',
  en_gb = 'GBP',
  en_nl = 'EUR',
  en_nz = 'NZD',
  en_us = 'USD',
  en_kr = 'KRW',
  en_za = 'ZAR',
  es_es = 'EUR',
  fr_ca = 'CAD',
  fr_ch = 'CHF',
  fr_fr = 'EUR',
  it_ch = 'CHF',
  ko_kr = 'KRW',
  nl_nl = 'EUR',
  pt_pt = 'EUR',
}

export enum MONEY_FORMAT {
  ca_es = '€EU',
  de_ch = 'CHF',
  de_de = '€EU',
  en_aq = '$US',
  en_ca = '$CA',
  en_ch = 'CHF',
  en_de = '€EU',
  en_es = '€EU',
  en_gb = 'GB£',
  en_nl = '€EU',
  en_nz = 'NZ$',
  en_us = '$US',
  en_kr = 'KRW',
  en_za = 'ZAR',
  es_es = '€EU',
  fr_ca = 'CA$',
  fr_ch = 'CHF',
  fr_fr = '€EU',
  it_ch = 'CHF',
  ko_kr = 'KRW',
  nl_nl = '€EU',
  pt_pt = '€EU',
}

export const CURRENCY_PREFIX = {
  [LOCALES.ca_es]: '€',
  [LOCALES.de_ch]: 'CHF',
  [LOCALES.de_de]: '€',
  [LOCALES.en_aq]: '$',
  [LOCALES.en_ca]: '$',
  [LOCALES.en_ch]: 'CHF',
  [LOCALES.en_de]: '€',
  [LOCALES.en_gb]: '£',
  [LOCALES.en_nl]: '€',
  [LOCALES.en_nz]: 'NZD',
  [LOCALES.en_us]: '$',
  [LOCALES.en_kr]: 'KRW',
  [LOCALES.en_za]: 'ZAR',
  [LOCALES.en_es]: '€',
  [LOCALES.es_es]: '€',
  [LOCALES.fr_ca]: '$',
  [LOCALES.fr_ch]: 'CHF',
  [LOCALES.fr_fr]: '€',
  [LOCALES.it_ch]: 'CHF',
  [LOCALES.ko_kr]: 'KRW',
  [LOCALES.nl_nl]: '€',
  [LOCALES.pt_pt]: '€',
};

export type LocaleData = {
  code: LOCALES;
  region: REGIONS;
  language: LANGUAGES;
  moneyFormat?: MONEY_FORMAT;
  currencyCodeFormat?: CURRENCY_CODE_FORMAT;
};

export type SupportedReadableRegions = {
  AQ: string;
  CA: string;
  CH: string;
  DE: string;
  ES: string;
  FR: string;
  GB: string;
  KR: string;
  NL: string;
  NZ: string;
  PT: string;
  US: string;
  ZA: string;
};

export type SupportedReadableLanguages = {
  ca?: string;
  de?: string;
  en?: string;
  es?: string;
  fr?: string;
  it?: string;
  ko?: string;
  nl?: string;
  pt?: string;
};
